import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import CloseIcon from '@mui/icons-material/Close'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import EventIcon from '@mui/icons-material/Event'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import PaymentIcon from '@mui/icons-material/Payment'
import { AppBar, Box, Button, Container, IconButton, Tab, Toolbar, Typography, LinearProgress, Chip } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import ImageListItem from '@mui/material/ImageListItem'
import ImageListItemBar from '@mui/material/ImageListItemBar'
import Slide from '@mui/material/Slide'
import * as React from 'react'
import Facebook from './FacebookIcone.png'
import Instagram from './Instagram logo.png'
import LinkedIn from './Linkedinicone.png'
// import './ViewContact.scss'

import isEmpty from 'lodash/isEmpty'
import { makeGetRequest } from 'utils/api'
import { useSearchParams } from 'react-router-dom'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import MoneyBetweenUs from './MoneyBetweenUs'
import CalendarEvents from './CalendarEvents'
import ContactDocuments from './ContactDocuments'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ViewContact({ viewLink = false, open = false, id, setModalOpen }) {
  const siteUser = useSelector((store) => store.user)

  const [isOpen, setOpen] = React.useState(false)
  const [user, setUser] = React.useState({})
  const [isGetUser, setGetUser] = React.useState(false)
  const [userID, setUserID] = React.useState(id)
  const [searchParams, setSearchParams] = useSearchParams()
  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  // Quick action handlers
  const handleCall = () => {
    if (user.Portable) {
      window.location.href = `tel:${user.Portable}`
    } else if (user.Telephone) {
      window.location.href = `tel:${user.Telephone}`
    } else {
      alert('No phone number available')
    }
  }

  const handleEmail = () => {
    if (user.Email) {
      window.location.href = `mailto:${user.Email}`
    } else {
      alert('No email address available')
    }
  }

  const handleCreateEvent = () => {
    // Switch to the Calendrier tab to create event
    setValue('3')
  }

  const handleFinanceOperation = () => {
    // Switch to the Comptes tab to show financial operations
    setValue('2')
  }

  const handleRequestPayment = () => {
    // Switch to the Comptes tab where payment request is available
    setValue('2')
  }

  // Get completeness color
  const getCompletenessColor = (completeness) => {
    if (completeness >= 80) return 'success'
    if (completeness >= 50) return 'warning'
    return 'error'
  }
  React.useEffect(() => {
    const getUserData = async () => {
      const getUser = await makeGetRequest(`/api/Social/get-contact/${userID}`, {}, true)
      if (getUser.data.length > 0) {
        setUser(getUser.data[0])
        setOpen(true)
      } else {
        handleClose()
        alert('Contact not found!')
      }
    }
    if (isGetUser) {
      getUserData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGetUser])

  // React.useEffect(() => {
  //   setOpen(open)
  // }, [userID])

  React.useEffect(() => {
    setUserID(id)
    setGetUser(true)
  }, [id])

  function handleClickOpen() {
    setOpen(true)
    setGetUser(true)
  }

  function handleClose() {
    setOpen(false)
    setGetUser(false)
    setModalOpen(null)
    if (searchParams.has('cid')) {
      searchParams.delete('cid')
      setSearchParams(searchParams)
    }
  }

  // const userPicture = user.Picture // ?.replace('/images/', '/images/ContactAvatars/')
  const generalInformation = (
    <>
      <div>
        <div padding="2px" color="white">
          <div
            style={{
              marginLeft: '30px',
            }}
          >
            {user && user.Portable !== 'undefined' && (
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ textAlign: 'left' }}>{user.Portable || ''}</h5>
                <div
                  style={{
                    color: 'gray',
                    textAlign: 'left',
                    marginBottom: '15px',
                    fontSize: '1rem',
                  }}
                >
                  Portable
                </div>
              </div>
            )}
            {user && user.Telephone !== 'undefined' && (
              <div>
                <h5 style={{ textAlign: 'left' }}>{user.Telephone || ''}</h5>
                <div
                  style={{
                    color: 'gray',
                    textAlign: 'left',
                    marginBottom: '15px',
                    fontSize: '1rem',
                  }}
                >
                  Téléphone pro
                </div>
              </div>
            )}
            {user && user.Email !== 'undefined' && (
              <div>
                <h5 style={{ textAlign: 'left' }}>{user.Email || ''}</h5>
                <div
                  style={{
                    textAlign: 'left',
                    marginBottom: '15px',
                    fontSize: '1rem',
                    color: 'gray',
                  }}
                >
                  Email
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div style={{ marginLeft: '40%', marginTop: '15px', justifyContent: 'right' }}>
        <Box>
          {!isEmpty(user.Facebook) && user.Facebook !== 'null' && user.Facebook !== 'undefined' ? (
            <a href={user.Facebook} target="_blank" rel="noreferrer" style={{ marginRight: '10px' }}>
              <img src={Facebook} alt="Facebook" width="85px"></img>
            </a>
          ) : (
            ''
          )}
          {!isEmpty(user.Instagram) &&
          user.Instagram !== 'null' &&
          user.Instagram !== 'undefined' ? (
            <a href={user.Instagram} target="_blank" rel="noreferrer" style={{ marginRight: '10px' }}>
              <img src={Instagram} alt="Instagram" width="85px"></img>
            </a>
          ) : (
            ''
          )}
          {!isEmpty(user.Linkedin) && user.Linkedin !== 'null' && user.Linkedin !== 'undefined' ? (
            <a href={user.Linkedin} target="_blank" rel="noreferrer">
              <img src={LinkedIn} alt="LinkedIn" width="85px"></img>
            </a>
          ) : (
            ''
          )}
        </Box>
      </div>
    </>
  )
  return (
    <div>
      {viewLink && (
        <Button variant="outlined" onClick={handleClickOpen}>
          <ArrowDropDownIcon />
        </Button>
      )}

      <Dialog
        fullScreen
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: '#00001D',
            color: '#fff',
          },
        }}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ color: '#fff', backgroundColor: 'black' }}>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {user.Nom} {user.Prenom}
            </Typography>
            {user.completeness !== undefined && (
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  Complétude du profil: {user.completeness}%
                </Typography>
                <Chip
                  label={`${user.completeness}%`}
                  color={getCompletenessColor(user.completeness)}
                  size="small"
                />
              </Box>
            )}
          </Toolbar>
        </AppBar>
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Quick Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mb: 3,
              mt: 2,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              startIcon={<PhoneIcon />}
              onClick={handleCall}
              // sx={{ bgcolor: '#4CAF50' }}
            >
              Appeler
            </Button>
            <Button
              variant="contained"
              startIcon={<EmailIcon />}
              onClick={handleEmail}
              // sx={{ bgcolor: '#2196F3' }}
            >
              Envoyer un Email
            </Button>
            <Button
              variant="contained"
              startIcon={<EventIcon />}
              onClick={handleCreateEvent}
              // sx={{ bgcolor: '#FF9800' }}
            >
              Créer un Événement
            </Button>
            <Button
              variant="contained"
              startIcon={<AccountBalanceWalletIcon />}
              onClick={handleFinanceOperation}
              // sx={{ bgcolor: '#9C27B0' }}
            >
              Opération Financière
            </Button>
            <Button
              variant="contained"
              startIcon={<PaymentIcon />}
              onClick={handleRequestPayment}
              // sx={{ bgcolor: '#F44336' }}
            >
              Demander Paiement
            </Button>
          </Box>

          {/* Completeness Progress Bar */}
          {user.completeness !== undefined && (
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ mb: 1, color: 'white' }}>
                Complétude du profil: {user.completeness}%
              </Typography>
              <LinearProgress
                variant="determinate"
                value={user.completeness}
                color={getCompletenessColor(user.completeness)}
                sx={{ height: 10, borderRadius: 5 }}
              />
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'left',
              flexWrap: 'wrap',
            }}
          >
            <div>
              {(user.Picture || user.picture_link) !== null ? (
                <Box
                  width="500px"
                  maxWidth="500px"
                  height="300px"
                  maxHeight={'300px'}
                  opacity="0.8"
                  marginRight="8px"
                >
                  <ImageListItem key={user.id} className="my-img">
                    <img
                      src={user.Picture || user.picture_link}
                      srcSet={user.Picture || user.picture_link}
                      alt={''}
                      loading="lazy"
                      maxHeight="300px"
                      height="300px"
                      maxWidth="500px"
                      width="500px"
                    />
                    <ImageListItemBar
                      sx={{ textAlign: 'center' }}
                      title={
                        <h3>
                          {user.Nom} {user.Prenom}
                        </h3>
                      }
                      subtitle={
                        <h5>
                          <i>{user.surnom !== null ? `"${user.surnom}"` : ''}</i>
                        </h5>
                      }
                      position="bottom"
                    />
                  </ImageListItem>
                </Box>
              ) : (
                <Box
                  backgroundColor="white"
                  color="black"
                  width="500px"
                  height="150px"
                  opacity="0.8"
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'center',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <h1>
                      {user.Nom} {user.Prenom}
                    </h1>
                    <h2 style={{ fontSize: '2rem' }}>
                      <i>{user.surnom !== null ? `"${user.surnom}"` : ''}</i>
                    </h2>
                  </div>{' '}
                </Box>
              )}
            </div>
            <div>
              <Box
                // backgroundColor="white"
                padding="10px"
                width="500px"
                height="280px"
                className="view-contact"
              >
                <Box color="blue" backgroundColor="#001b42" width="100%">
                  <h4 style={{ textAlign: 'left' }}>Informations du contact</h4>
                </Box>

                <div
                  style={{
                    color: 'white',
                    paddingTop: '10px',
                    padding: '10px 19px',
                    fontSize: '1.5rem',
                  }}
                >
                  {!isEmpty(user) && user.Anniversaire !== 'undefined' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        color: 'white',
                      }}
                    >
                      <h6 style={{ color: 'gray' }}>Anniversaire :</h6>
                      <h6 style={{ color: 'white' }}>
                        {user.Anniversaire
                          ? `${convertToUserDateFormate(siteUser.user, user.Anniversaire)}`
                          : 'N/A'}
                      </h6>
                    </div>
                  )}
                  {!isEmpty(user.Pays) && user.Pays !== 'undefined' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                      }}
                    >
                      <h6 style={{ color: 'gray' }}>Pays :</h6>
                      <h6 style={{ color: 'white' }}>
                        {user.Pays === undefined || user.Pays.length === 0
                          ? 'N/A'
                          : `${user.Pays[0].CountryCode} ${user.Pays[0].Nationality}`}
                      </h6>
                    </div>
                  )}
                  {!isEmpty(user.Job) && user.Job !== 'undefined' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                      }}
                    >
                      <h6 style={{ color: 'gray' }}>Job :</h6>
                      <h6 style={{ color: 'white' }}>{user.Job}</h6>
                    </div>
                  )}
                  {!isEmpty(user.Societe) && user.Societe !== 'undefined' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                      }}
                    >
                      <h6 style={{ color: 'gray' }}>Société :</h6>
                      <h6 style={{ color: 'white' }}>{user.Societe}</h6>
                    </div>
                  )}
                  {!isEmpty(user.Groupes) && user.Groupes !== 'undefined' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                      }}
                    >
                      <h6 style={{ color: 'gray' }}>Groupe :</h6>
                      <h6 style={{ color: 'white' }}>{user.Groupes[0].Name}</h6>
                    </div>
                  )}
                  {!isEmpty(user.Category) && user.Category !== 'undefined' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                      }}
                    >
                      <h6 style={{ color: 'gray' }}>Catégorie :</h6>
                      <h6 style={{ color: 'white' }}>{user.Category[0]?.Categorie}</h6>
                    </div>
                  )}
                  {!isEmpty(user.Category) &&
                    user.Category !== 'undefined' &&
                    user.Category[0].SousCategorie !== undefined && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          flexDirection: 'row',
                        }}
                      >
                        <h6 style={{ color: 'gray' }}>Sour Catégorie :</h6>
                        <h6 style={{ color: 'white' }}>{`${user.Category[0]?.SousCategorie}`}</h6>
                      </div>
                    )}
                </div>
              </Box>
            </div>
          </Box>
          <Box sx={{ width: '100%', typography: 'body1', mt: 5 }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange}>
                  <Tab sx={{ color: 'white' }} label="Général information" value="1" />
                  <Tab sx={{ color: 'white' }} label="Comptes" value="2" />
                  <Tab sx={{ color: 'white' }} label="Calendrier" value="3" />
                  <Tab sx={{ color: 'white' }} label="Document" value="4" />
                </TabList>
              </Box>
              <TabPanel value="1">{generalInformation}</TabPanel>
              <TabPanel value="2">
                <MoneyBetweenUs contactId={userID} />
              </TabPanel>
              <TabPanel value="3">
                <CalendarEvents contactId={userID} />
              </TabPanel>
              <TabPanel value="4">
                <ContactDocuments contactId={userID} />
              </TabPanel>
            </TabContext>
          </Box>
        </Container>
      </Dialog>
    </div>
  )
}
